import React from 'react';
import '../../css/Loader.css';

interface LoaderProps {
  size?: 'small' | 'medium' | 'large';
  text?: string;
  inline?: boolean;
}

const Loader: React.FC<LoaderProps> = ({ size = 'medium', text = 'Loading...', inline = false }) => {
  if (inline) {
    return (
      <div className="loader-table-row">
        <div className={`loader-spinner ${size}`}></div>
        <span className={`loader-text ${size}`}>{text}</span>
      </div>
    );
  }

  return (
    <div className="loader-container">
      <div className={`loader-spinner ${size}`}></div>
      {text && <div className={`loader-text ${size}`}>{text}</div>}
    </div>
  );
};

export default Loader;
